import React from 'react'
import * as moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { appendDeletionArray, subtractDeletionArray, changeContactListsModal, setActiveContactListDeletion, setActiveContactListDisplay } from '../../../../../redux/actions/contact-lists'
import { ChangeIconButton, DeleteIconButton, InfoTableButton } from '../../../../library/button'
import { Checkbox } from '../../../../library/checkbox'

const Index = ({singleList, index, arr }) => {

    const dispatch = useDispatch()
    const history = useHistory()

    const deletions = useSelector(state => state.contactLists.deletionArray)

    const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)

    const clickEditSingleContactList = list => {
        if(activeCompany.subscription){
            dispatch(changeContactListsModal({editModal: true}))
            dispatch(setActiveContactListDisplay({
                id: list.id,
                name: list.name ? list.name:null,
                description: list.description ? list.description:null
            }))
        }
    }

    const determineSettingsHoverButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const clickDeleteSingleContactList = id => {
        if(activeCompany.subscription){
            dispatch(setActiveContactListDeletion({id: id}))
            dispatch(changeContactListsModal({deleteModal: true}))
        }
    }

    const formatSizeNumber = number => {
        const value = number
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    }

    const handleSingleSelection = (e, id) => {
        if(e.target.checked){
            if(!deletions.includes(id)){
                dispatch(appendDeletionArray(id))
            }
        } else {
            if(deletions.includes(id)){
                dispatch(subtractDeletionArray(id))
            }
        }
    }

    const determineSettingsDeleteButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const determineTitleHover = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const handleNavigation = id => {
        history.push(`/dashboard/kontaktliste/${id}`)
    }

    return(
        <tr key={singleList.key} className={index === (arr.length - 1) && "last"}>
            <td><Checkbox key={singleList.id} contactListId={singleList.id} name="contactListId" onChange={(e) => handleSingleSelection(e, singleList.id)} checked={deletions.includes(singleList.id) ? true:false} type="checkbox" id="select"/></td>
            <td onClick={() => handleNavigation(singleList.id)}><span className="contact-title">{singleList.name}</span></td>
            <td onClick={() => handleNavigation(singleList.id)}>{singleList.addedBy}</td>
            <td onClick={() => handleNavigation(singleList.id)}><InfoTableButton color='blue' title={formatSizeNumber(singleList.size)}/></td>
            <td onClick={() => handleNavigation(singleList.id)}>{moment.unix(singleList.timestamp).format('HH:MM DD/MM/YYYY')}</td>
            <td><ChangeIconButton data-tip={determineSettingsHoverButton()} onClick={() => clickEditSingleContactList(singleList)}/><DeleteIconButton data-tip={determineSettingsDeleteButton()} onClick={() => clickDeleteSingleContactList(singleList.id)}/></td>
        </tr>
    )
}

export default Index




